import { keyMirror } from 'ramda-extension';

export const textBooksCacheKeys = keyMirror({
	SINGLE_TEXT_BOOK: null,
	ALL_TEXT_BOOKS: null,
	ALL_DECKS_FOR_TEXT_BOOK: null,
	ALL_TEXTBOOKS_BY_ID: null,
	PUBLISHED: null,
});
